"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setTaskViewSidebarOpen = exports.TASK_VIEW_SIDEBAR_TOGGLE = exports.setTaskViewSelectedTreeNodePath = exports.TASK_VIEW_SELECTED_TREE_NODE_PATH = exports.resetTaskViewTable = exports.RESET_TASK_VIEW_TABLE = exports.setTaskViewTablePageSize = exports.SET_TASK_VIEW_TABLE_PAGE_SIZE = exports.setTaskViewTableRowSize = exports.SET_TASK_VIEW_TABLE_ROW_SIZE = exports.setTaskViewTableSort = exports.SET_TASK_VIEW_TABLE_SORT = exports.setTaskViewTableSearch = exports.SET_TASK_VIEW_TABLE_SEARCH = exports.setTaskViewTableFilter = exports.SET_TASK_VIEW_TABLE_FILTER = void 0;
const actions_1 = require("../../shared/table-config/actions");
const constants_1 = require("../../shared/table-config/constants");
const actions_2 = require("../actions");
const TASK_VIEW_PREFIX = `${actions_2.CATALOG_PREFIX}${constants_1.TableEntityPrefix.HLQATaskView}`;
exports.SET_TASK_VIEW_TABLE_FILTER = `${TASK_VIEW_PREFIX}${actions_1.SET_TABLE_FILTER_ACTION}`;
exports.setTaskViewTableFilter = (0, actions_1.setTableFilterActionCreator)(exports.SET_TASK_VIEW_TABLE_FILTER);
exports.SET_TASK_VIEW_TABLE_SEARCH = `${TASK_VIEW_PREFIX}${actions_1.SET_TABLE_SEARCH_ACTION}`;
exports.setTaskViewTableSearch = (0, actions_1.setTableSearchActionCreator)(exports.SET_TASK_VIEW_TABLE_SEARCH);
exports.SET_TASK_VIEW_TABLE_SORT = `${TASK_VIEW_PREFIX}${actions_1.SET_TABLE_SORT_ACTION}`;
exports.setTaskViewTableSort = (0, actions_1.setTableSortActionCreator)(exports.SET_TASK_VIEW_TABLE_SORT);
exports.SET_TASK_VIEW_TABLE_ROW_SIZE = `${TASK_VIEW_PREFIX}${actions_1.SET_ROW_SIZE_ACTION}`;
exports.setTaskViewTableRowSize = (0, actions_1.setRowSizeActionCreator)(exports.SET_TASK_VIEW_TABLE_ROW_SIZE);
exports.SET_TASK_VIEW_TABLE_PAGE_SIZE = `${TASK_VIEW_PREFIX}${actions_1.SET_PAGE_SIZE_ACTION}`;
exports.setTaskViewTablePageSize = (0, actions_1.setPageSizeActionCreator)(exports.SET_TASK_VIEW_TABLE_PAGE_SIZE);
exports.RESET_TASK_VIEW_TABLE = `${TASK_VIEW_PREFIX}RESET_TABLE`;
const resetTaskViewTable = (catalogId) => ({
    type: exports.RESET_TASK_VIEW_TABLE,
    payload: {
        id: catalogId,
    },
});
exports.resetTaskViewTable = resetTaskViewTable;
exports.TASK_VIEW_SELECTED_TREE_NODE_PATH = `${TASK_VIEW_PREFIX}SET_TREE_NODE_PATH`;
const setTaskViewSelectedTreeNodePath = (catalogId, changes) => ({
    type: exports.TASK_VIEW_SELECTED_TREE_NODE_PATH,
    payload: {
        id: catalogId,
        changes,
    },
});
exports.setTaskViewSelectedTreeNodePath = setTaskViewSelectedTreeNodePath;
exports.TASK_VIEW_SIDEBAR_TOGGLE = `${TASK_VIEW_PREFIX}SIDEBAR_TOGGLE`;
const setTaskViewSidebarOpen = (catalogId, changes) => ({
    type: exports.TASK_VIEW_SIDEBAR_TOGGLE,
    payload: {
        id: catalogId,
        changes,
    },
});
exports.setTaskViewSidebarOpen = setTaskViewSidebarOpen;
